var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4"},[_c('v-card-title',[_vm._v("Configuração do Produto "+_vm._s(_vm.produto.descricao))]),_c('v-divider',{staticClass:"my-4"}),_c('config-produto-edit',{attrs:{"produto":_vm.produto}}),_c('v-divider',{staticClass:"my-4"}),_c('config-produto-caracteristicas',{attrs:{"produto":_vm.produto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }